import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "fw-bolder" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("Booked workers ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("h3", _hoisted_1, [
    (_ctx.crewStatus)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.crewStatus) + " - ", 1))
      : _createCommentVNode("", true),
    _hoisted_3
  ]))
}